import client from '../../apollo';

export default client.reducer();



// WEBPACK FOOTER //
// /src/store/reducers/apolloReducer.js